import i18n from "src/i18n";

import { STORAGE_KEYS } from "@constants/Kiosk";
import {
  DefaultType,
  LocalizationObjectType,
  TerminologyLocaleType,
} from "@models/utils/localisation.models";
import { store } from "@store/index";

import { getVisitorId } from "../lib/fingerprint";

const getApiHeader = async () => {
  const { accessToken } = store.getState().local;

  const appMode =
    import.meta.env.VITE_APP_TARGET === "kiosk" ? "KIOSK" : "WEBAPP";

  const kioskDeviceIdRaw = localStorage.getItem(STORAGE_KEYS.KIOSK_DEVICE_ID);
  const kioskDeviceId = kioskDeviceIdRaw ? JSON.parse(kioskDeviceIdRaw) : null;
  const { visitorId } = await getVisitorId();

  const head: { [key: string]: string } = {
    Accept: "application/json",
    ["Accept-Language"]: i18n.language,
    // Accept: "*/*",
  };
  if (accessToken) {
    head["Authorization"] = "Bearer " + accessToken;
  }

  head["X-AUTH-DEVICE"] = appMode;

  if (visitorId) head["X-AUTH-KIOSK-DEVICE"] = visitorId;

  head["X-AUTH-KIOSK-ID"] = kioskDeviceId ?? "";

  head["Content-Type"] = "application/json";

  return head;
};

export const applyLocalization = (
  object: LocalizationObjectType,
  key?: string,
  t?: (value: string) => string
) => {
  const language = i18n.language;

  if (!object?.locales) return key ? (t ? t(key) : key) : "";

  if (key) {
    const locales = object.locales as TerminologyLocaleType;
    const defaultObj = object["default"] as DefaultType;
    const defaultKey = defaultObj?.[key] ? defaultObj?.[key] : t ? t(key) : key;

    return locales[language]?.[key] ? locales[language][key] : defaultKey;
  }
  const localeDefaultKey = (object.default as string)
    ? (object.default as string)
    : "";
  return object?.locales[language]
    ? (object?.locales[language] as string)
    : localeDefaultKey;
};

export default {
  applyLocalization,
  getApiHeader,
};
